<script>
    import {Doughnut} from 'vue-chartjs'
    import {Utils} from '@payroll/optimus-common'

    require('./js/utils.js')

    export default {
        extends: Doughnut,
        props: ['dataProp', 'chartLegendId', 'totalIsCurrency', 'totalIsDecimal'],
        data() {
            return {
                options: {
                    hover: {
                        animationDuration: 0
                    },
                    legendCallback: function (chart) {
                        window.doughtnutChart = chart

                        var defaultLegendClickHandler = Chart.defaults.global.legend.onClick
                        var text = []
                        text.push('<ul class="' + chart.id + '-legend row">')

                        var data = chart.data
                        var datasets = data.datasets
                        var labels = data.labels
                        if (labels.length > 1) {
                            for (var i = 0; i < datasets[0].data.length; ++i) {
                                text.push('<li class="col-' + (chart.options.isMobile ? '4' : '12') + '"><span class="chart-legend" style="background-color:' + datasets[0].backgroundColor[i] + '"></span>')
                                if (labels[i]) {
                                    text.push('<div class="chart-legend-label-text" onclick="updateDataset(event, ' + '\'' + chart.legend.legendItems[i].index + '\')">' +
                                        '<h4 class="chart-legend-title ltr">' + datasets[0].data[i] + '%' + '</h4>' +
                                        '<p class="chart-legend-subtitle">' + labels[i] + '</p>' + '</div>'
                                    )
                                }
                                text.push('</li>')
                            }
                        } else if (labels.length === 1) {
                            text.push('<li class="col-4"><span class="chart-legend" style="background-color:' + datasets[0].backgroundColor[0] + '"></span>')
                            if (labels[0]) {
                                text.push('<div>' +
                                    '<h4 class="chart-legend-title ltr">' + datasets[0].data[0] + '%' + '</h4>' +
                                    '<p class="chart-legend-subtitle">' + labels[0] + '</p>' + '</div>'
                                )
                            }
                            text.push('</li>')

                        }
                        text.push('</ul>')
                        return text.join('')
                    },
                    tooltips: {
                        backgroundColor: 'rgba(0,0,0,1)',
                        callbacks: {
                            label: function (tooltipItem, data) {
                                var label = data.labels[tooltipItem.index]
                                label = label ? (data.labelPrefix + label) : ''
                                if (label) {
                                    label += ': ' + data.datasets[0].values[tooltipItem.index]
                                }

                                return label
                            }
                        }
                    },
                    legend: {
                        display: false,
                    },
                    elements: {
                        arc: {
                            borderWidth: 0
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: true,
                    cutoutPercentage: 73,
                    animation: {
                        onComplete: function (event) {
                            var chartInstance = this.chart,
                                context = chartInstance.ctx
                            var xCenter = this.chart.width / 2
                            var yCenter = this.chart.height / 2
                            var total = 0
                            var fontSize = 35
                            const largeScreen = 1844
                            const bigScreen = 1618
                            const medScreen = 1366
                            const smallScreen = 830
                            var screenWidth = window.screen.width

                            context.textAlign = 'center'
                            context.textBaseline = 'middle'
                            this.data.datasets.forEach(function (dataset, i) {
                                var meta = chartInstance.controller.getDatasetMeta(i)
                                meta.data.forEach(function (bar, index) {
                                    var data = dataset.values[index]
                                    if (!bar.hidden) {
                                        total += data
                                    }
                                })
                            })
                            if (screenWidth <= largeScreen) {
                                fontSize = 30
                            }
                            if (screenWidth <= bigScreen) {
                                fontSize = 26
                            }
                            if (screenWidth <= medScreen) {
                                fontSize = 20
                            }

                            if (total >= Math.pow(10, 6)) {
                                fontSize = 30

                                if (screenWidth <= largeScreen) {
                                    fontSize = 26
                                }
                                if (screenWidth <= bigScreen) {
                                    fontSize = 22
                                }
                                if (screenWidth <= medScreen) {
                                    fontSize = 24
                                }
                                if (screenWidth <= smallScreen) {
                                    fontSize = 20
                                }
                            }

                            var progressLabel = total
                            if (this.chart.options.totalIsDecimal) {
                                progressLabel = progressLabel.toFixed(2)
                            } else {
                                progressLabel = progressLabel.toFixed()
                            }
                            progressLabel = progressLabel.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
                            if (this.chart.options.totalIsCurrency) {
                                progressLabel += " ₪"
                            }
                            context.font = fontSize + 'px Helvetica'
                            context.fillStyle = 'black'
                            context.fillText(progressLabel, xCenter, yCenter)
                        }
                    }
                }
            }
        },

        mounted() {
            if (this.dataProp.datasets) {
                this.dataProp.datasets.forEach((dataset) => {
                    if (dataset.backgroundColor.length === 0) {
                        dataset.backgroundColor = ['#080088', '#ff3702', '#cfaf00', '#4da1ff', '#404f63', '#7460ee']
                    }
                })
            }
            this.options.totalIsCurrency = this.totalIsCurrency
            this.options.totalIsDecimal = this.totalIsDecimal
            this.options.isMobile = Utils.isMobile()
            this.renderChart(this.dataProp, this.options)
            document.getElementById(this.chartLegendId).innerHTML = this._data._chart.generateLegend()
        }
    }
</script>

<style lang="scss">
    #distribution-chart-legend {
        .chart-legend-label-text:hover {
            cursor: pointer;
        }

        .chart-legend {
            position: absolute;
            content: "";
            height: 8px;
            width: 8px;
            right: 0;
            top: 7px;
            border-radius: 50%;
        }

        .chart-legend-title {
            font-size: 22px;
            margin: 0;
        }

        .chart-legend-subtitle {
            color: #232425;
            opacity: 0.5;
            font-size: 14px;
        }

        .strikeThrough {
            text-decoration: line-through;
        }
    }
</style>